// src/hooks/useDocumentTitle.ts
import { useEffect } from 'react';

/** Titulo por defecto, igual al de public/index.html */
export const DEFAULT_TITLE = 'Caramba! - Tu voto importa | Monitorea el Congreso de Chile';

/** Dominio canonico del sitio */
export const CANONICAL_ORIGIN = 'https://www.carambatuvoto.com';

/**
 * Fija el <title> de la pagina mientras el componente esta montado.
 * Pasa null o undefined mientras los datos cargan: queda el titulo por defecto.
 */
export function useDocumentTitle(title?: string | null): void {
  useEffect(() => {
    document.title = title ? `${title} | Caramba! Tu voto importa` : DEFAULT_TITLE;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
}

/**
 * Mantiene el <link rel="canonical"> apuntando al dominio canonico + la ruta actual.
 * Sin esto, el canonical estatico de index.html declararia que todas las rutas
 * son duplicados de la portada.
 */
export function useCanonicalUrl(pathname: string): void {
  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (link) {
      link.href = `${CANONICAL_ORIGIN}${pathname}`;
    }
  }, [pathname]);
}
